import add from "./add";
import align from "./align";
import arrayPanel from "./array-panel";
import copy from "./copy";
import deleteButton from "./delete";
import filter from "./filter";
import group from "./group";
import highlight from "./highlight";
import menu from "./menu";
import more from "./more";
import move from "./move";
import paste from "./paste";
import printMap from "./print-map";
import redo from "./redo";
import rotate from "./rotate";
import search from "./search";
import select from "./select";
import subtract from "./subtract";
import undo from "./undo";

export default {
    add,
    group,
    move,
    align,
    copy,
    paste,
    delete: deleteButton,
    filter,
    highlight,
    menu,
    more,
    redo,
    search,
    select,
    subtract,
    undo,
    printMap,
    rotate,
    arrayPanel,
};
